import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=8a44e0be&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&lang=js&"
export * from "./TaskItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=8a44e0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a44e0be",
  null
  
)

export default component.exports